import classNames from 'classnames';
import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import {
    section,
  } from './ContentList2.module.css';
  
export default function ContentList2({ data }) {
    const { contentList2BottomText, contentList2ButtonText, contentList2TranslateText, contentList2Block, contentList2ButtonLink } = data
    return (
        <div className={classNames('global-image-content-wrap', section)}>
            <div className='container'>
                {contentList2Block?.map((item, index) => (
                    <div className='row' key={index}>
                        <div className='col-md-6 gc-img-col'>
                            <GatsbyImage
                                image={getImage(item.contentList2BlockImage.localFile)}
                                alt='image'
                            />
                        </div>
                        <div className='col-md-6 gc-c-col'>
                            <div className='global-img-content-rt-sec'>
                                <h3 className='heading-level-3 blue-color'>
                                    {item.contentList2BlockTitle && parser(item.contentList2BlockTitle)}
                                </h3>
                                {item.contentList2BlockText && parser(item.contentList2BlockText)}
                            </div>
                        </div>
                    </div>
                ))}                
                
                {contentList2BottomText && (
                <div className='row text-center gc-download-matrix-sec'>
                    <div className='col-md-12'>
                        <h2 className='heading-level-4-b black-color'>
                            {contentList2BottomText && parser(contentList2BottomText)}
                        </h2>
                        {contentList2ButtonLink && (
                            <a
                                href={contentList2ButtonLink.localFile.publicURL}
                                target='_blank'
                                className='btn blue-btn'
                                rel='noreferrer'
                            >
                                {contentList2ButtonText}
                            </a>
                        )}
                        {contentList2TranslateText && parser(contentList2TranslateText)}                           
                        
                    </div>
                </div> )}
            </div>
        </div>
    )
}
